<form [formGroup]="filterForm">
  <div class="filterBlock " id="filterBlock" *ngIf="showFilters">
    <mat-form-field appearance="outline">
      <span matPrefix><img src="assets/images/icons/gray/magnifying-glass 1.png" alt="search-icon"
          class="ico--sm" /></span>
      <input matInput placeholder="type to filter" type="search" formControlName="textInput"
        (input)="onSearchTextChange($event.target.value)">
    </mat-form-field>
  </div>
</form>
<div class="filterButtons" *ngIf="showFilters">
  <ul class="button__group">

    <ng-container>
      <li *ngIf="isValuesTree" class="button__groupItem"
        (click)="onOrderToggleClick(treeOrderDirection.asc,treeOrderType.custom)">
        <button class="iconButton iconButton--sm iconButton--transparent" matTooltip="Sort by order">
          <img src="assets/images/icons/blue/sort-by-order.png" alt="Sort by order">
        </button>
      </li>
      <li class="button__groupItem" (click)="onOrderToggleClick(treeOrderDirection.asc,treeOrderType.default)">
        <button class="iconButton iconButton--sm iconButton--transparent" matTooltip="Sort by alphabet">
          <img src="assets/images/icons/blue/sort-by-alphabet.png" alt="Sort by alphabet">
        </button>
      </li>
      <li class="button__groupItem" (click)="onOrderToggleClick(treeOrderDirection.desc,treeOrderType.default)">
        <button class="iconButton iconButton--sm iconButton--transparent" matTooltip="Sort by alphabet reverse">
          <img src="assets/images/icons/blue/sort-reverse-alphabetical-order.png" alt="Sort by alphabet reverse">
        </button>
      </li>
    </ng-container>
    <li class="button__groupItem" (click)="onExpandAll()">
      <button class="iconButton iconButton--sm iconButton--transparent" matTooltip="Expand all">
        <img src="assets/images/icons/blue/ExpandAll.png" alt="Expand all">
      </button>
    </li>
    <li class="button__groupItem" (click)="onCollapseAll()">
      <button class="iconButton iconButton--sm iconButton--transparent" matTooltip="Collapse all">
        <img src="assets/images/icons/blue/CollapseAll.png" alt="Collapse all">
      </button>
    </li>
  </ul>
</div>

<app-virtual-tree #vTree *ngIf="treeView" class="k-widget k-treeview" [model]="treeModel" [addNew]="adding"
  [itemHeight]="25" [ngClass]="{'treeFilter' : showFilters && !collapse}" [templateRef]="treeTemplate">
</app-virtual-tree>

<ng-template #treeTemplate let-node>

  <div [ngClass]="'nodeLevel-'+node.depth" (click)="selectItem(node.item);" (dblclick)="onConfirmSelection()">

    <span class="k-icon "
      [ngClass]="{ 'k-i-expand': treeModel.isExpandable(node.item), 'k-i-collapse': treeModel.isExpanded(node.item) } "
      (click)="expandItem(node.item); $event.stopPropagation() "></span>

    <div class="k-in " [ngClass]="getNodeClasses(node)">

      <ng-container [ngSwitch]="node.item.type ">

        <ng-container *ngSwitchDefault>
          <span class="treeview__label " [innerHTML]="getItemLabel(node.item) " class="treeValue "></span>
        </ng-container>
      </ng-container>
    </div>

  </div>
</ng-template>
<div class="treeview__legend " *ngIf="showLegend ">
  <ul class="treeview__legendList ">
    <li class="treeview__legendItem ">
      <span class="entity ">Entities</span>
    </li>
    <li class="treeview__legendItem ">
      <span class="attribute ">Attributes</span>
    </li>
    <li class="treeview__legendItem ">
      <span class="linked ">Linked</span>
    </li>
  </ul>
</div>
